export default __webpack_public_path__ + "static/media/IMG_5235.b727bf3a.JPG";